export var MethodName;
(function (MethodName) {
    MethodName["GetAccount"] = "getAccount";
    MethodName["GetApplicationLog"] = "getApplicationLog";
    MethodName["GetNep17Balances"] = "getNep17Balances";
    MethodName["GetBlock"] = "getBlock";
    MethodName["GetBlockCount"] = "getBlockCount";
    MethodName["GetNetworks"] = "getNetworks";
    MethodName["GetProvider"] = "getProvider";
    MethodName["GetStorage"] = "getStorage";
    MethodName["GetTransaction"] = "getTransaction";
    MethodName["InvokeRead"] = "invokeRead";
    MethodName["InvokeReadMulti"] = "invokeReadMulti";
    MethodName["Invoke"] = "invoke";
    MethodName["InvokeMulti"] = "invokeMulti";
})(MethodName || (MethodName = {}));
export var ArgumentType;
(function (ArgumentType) {
    ArgumentType["Any"] = "Any";
    ArgumentType["Boolean"] = "Boolean";
    ArgumentType["Integer"] = "Integer";
    ArgumentType["ByteArray"] = "ByteArray";
    ArgumentType["String"] = "String";
    ArgumentType["Hash160"] = "Hash160";
    ArgumentType["Hash256"] = "Hash256";
    ArgumentType["PublicKey"] = "PublicKey";
    ArgumentType["Signature"] = "Signature";
    ArgumentType["Array"] = "Array";
    ArgumentType["Map"] = "Map";
    ArgumentType["InteropInterface"] = "InteropInterface";
    ArgumentType["Void"] = "Void";
})(ArgumentType || (ArgumentType = {}));
export var AttributeUsage;
(function (AttributeUsage) {
    AttributeUsage["Url"] = "Url";
})(AttributeUsage || (AttributeUsage = {}));
export var SignerScope;
(function (SignerScope) {
    SignerScope["None"] = "None";
    SignerScope["CalledByEntry"] = "CalledByEntry";
    SignerScope["CustomContracts"] = "CustomContracts";
    SignerScope["CustomGroups"] = "CustomGroups";
    SignerScope["Global"] = "Global";
})(SignerScope || (SignerScope = {}));
//# sourceMappingURL=enums.js.map